import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { delay, finalize, map, takeUntil, tap } from 'rxjs/operators';

import { PageNames } from 'src/app/configs/page-names.enum';
import { EventTypes } from 'src/app/core/constants/event-types';
import { AppDomService } from 'src/app/core/services/dom.service';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import {
  ComparisonObjectsWithLogicalOperators,
  CustomResultOfPaginatedListOfPrivateNumberPricesWithPaginationForUserDto,
  GetEnumValuesDto,
  PaginatedListOfPrivateNumberPricesWithPaginationForUserDto,
} from '../../../core/api/models';
import { PrivateNumberPricesWithPaginationForUserDto } from '../../../core/api/models/private-number-prices-with-pagination-for-user-dto';
import { PrivateNumberBuyRequestService } from '../../../core/api/services';
import { PrivateNumberPriceService } from '../../../core/api/services/private-number-price.service';
import { RefreshMenuService } from '../../../core/services/refresh-menu.service';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { PrivateNumberPriceForUserFormComponent } from './private-numbers-price-for-user-form/private-numbers-price-for-user-form.component';

@Component({
    selector: 'app-private-numbers-price-for-user',
    templateUrl: './private-numbers-price-for-user.component.html',
    styleUrls: [`./private-numbers-price-for-user.component.scss`],
    standalone: false
})
export class PrivateNumbersPriceForUserComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region properties

  pageName = PageNames.privateNumbersPriceForUser;
  modelWithPagination$: Observable<PaginatedListOfPrivateNumberPricesWithPaginationForUserDto>;
  items$: Observable<Array<PrivateNumberPricesWithPaginationForUserDto>>;
  items: PrivateNumberPricesWithPaginationForUserDto[] = [];

  SmsCpEnumValues: GetEnumValuesDto[] = [];
  buyButtonLoading: boolean = false;

  //milliseconds delay after the user stops scrolling;
  throttle = 300;
  // is event is triggered when 90% (100% - 10%) has been scrolled
  infiniteScrollDistance = 1; // 1 ==> 10%

  //#endregion

  constructor(
    protected currentService: PrivateNumberPriceService,
    private privateNumberBuyRequestService: PrivateNumberBuyRequestService,
    private dynamicTabService: DynamicTabService,
    public refreshMenuService: RefreshMenuService
  ) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showAuditBtn = false;
      this.pageConfig.isShowTable = false;
      this.setPageService(this.currentService, 'privateNumberPriceCreateGet');
    } catch (error) {
      this.loggerService?.logError(
        this.tagName,
        error,
        EventTypes.privateNumberPrice
      );
    }
  }

  initTablePagination() {
    this.paginationModel.pageIndex = 1;
    this.paginationModel.firstIndex = 1;
    this.paginationModel.pageNumber = 1;
    this.paginationModel.pageSize = 12;
  }

  // getTableData() {

  //   super.getTableData();

  // }

  getItems() {
    try {
      this.modelWithPagination$
        .pipe(
          tap((item) => {
            this.getPaginationData(item);
          }),
          map((item) => item?.items),
          tap((items) => {
            items?.length > 0
              ? (this.pageConfig.isEmpty = false)
              : (this.pageConfig.isEmpty = true);
          }),
          takeUntil(this.onDestroy$),
          delay(300),
          finalize(() => {
            this.pageConfig.loading = false;
          })
        )
        .subscribe((items) => {
          this.items = this.items.concat(items);
        });
    } catch (error) {
      this.loggerService?.logError(
        this.tagName,
        error,
        EventTypes.privateNumberPrice
      );
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('SmsCp')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsCpEnumValues = values));
  }

  configTableColumns(): void {}

  //#region api

  //get All
  getPaginationApi(): Observable<CustomResultOfPaginatedListOfPrivateNumberPricesWithPaginationForUserDto> {
    return this.currentService.privateNumberPriceGetPrivateNumberPricesWithPaginationForUser(
      {
        body: this.getBaseModelWithPaginationParams(),
      }
    );
  }

  //Create
  baseCreateGetApi(
    privateNumberPrice: PrivateNumberPricesWithPaginationForUserDto
  ) {
    this.unSubs();

    this.buyButtonLoading = true;

    this.privateNumberBuyRequestService
      .privateNumberBuyRequestCreateGet()
      .pipe(
        finalize(() => {
          this.buyButtonLoading = false;
        }),
        takeUntil(this.onDestroy$)
      )
      .subscribe((res) => {
        if (res) this.onBuyPrivateNumber(privateNumberPrice);
      });
  }

  //#endregion

  onBuyPrivateNumber(
    privateNumberPrice: PrivateNumberPricesWithPaginationForUserDto
  ) {
    this.unSubs();

    const modalResult = this.dialogService.openModal({
      component: PrivateNumberPriceForUserFormComponent,
      data: {
        privateNumberPrice: privateNumberPrice,
        SmsCpEnumValues: this.SmsCpEnumValues,
        vocabsPatch: this.formPageConfig.vocabs,
      },
    });

    modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((res) => {
        if (res) this.openPrivateNumberBuyRequests();
      });
  }

  openPrivateNumberBuyRequests() {
    this.dynamicTabService.setNewTab('');
    this.dynamicTabService.setNewTab('privateNumberBuyRequests');
    this.dynamicTabService.setActiveTab('privateNumberBuyRequests');
  }

  onScrollDown() {
    try {
      const totalCount = this.paginationModel.totalCount;

      if (this.items.length == totalCount) return;

      const totalPages = this.paginationModel.totalPages;
      const pageNumber = this.paginationModel.pageNumber;

      if (this.pageConfig.loading) return;

      this.pageConfig.loading = true;

      if (pageNumber < totalPages) this.paginationModel.pageNumber++;

      this.getTableData();
    } catch (error) {
      this.loggerService?.logError(
        this.tagName,
        error,
        EventTypes.privateNumberPrice
      );
    }
  }

  trackByFunc(
    index: number,
    item: PrivateNumberPricesWithPaginationForUserDto
  ) {
    try {
      return item.id;
    } catch (error) {
      this.loggerService?.logError(
        this.tagName,
        error,
        EventTypes.privateNumberPrice
      );
    }
  }

  getComparisonObjects(object: ComparisonObjectsWithLogicalOperators[]) {
    this.items = [];
    this.paginationModel.pageNumber = 1;
    this.comparisonObjects = object;
    this.pageConfig.tableConfig.comparisonObjects = Object.assign(
      [],
      this.comparisonObjects
    );
    this.getTableData();
  }
}
